// extracted by mini-css-extract-plugin
module.exports = {"form":"New__form___hdtyl","image_validation_message":"New__image_validation_message___1xQMU"};